import { createActionConst } from '../../../../utils/action.utils';

const TASK_SIMPLE_NAMESPACE = 'TASKS_SIMPLE';

export const CREATE_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'CREATE_TASK_SIMPLE');
export const CREATE_FORM_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'CREATE_FORM_TASK_SIMPLE');

export const UPDATE_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'UPDATE_TASK_SIMPLE');
export const UPDATE_FORM_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'UPDATE_FORM_TASK_SIMPLE');
export const DELETE_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'DELETE_TASK_SIMPLE');

export const UPDATE_GOAL_STATUS = createActionConst(TASK_SIMPLE_NAMESPACE, 'UPDATE_GOAL');

export const ADD_WATCHER = createActionConst(TASK_SIMPLE_NAMESPACE, 'ADD_WATCHER');
export const DELETE_WATCHER = createActionConst(TASK_SIMPLE_NAMESPACE, 'DELETE_WATCHER');

export const ADD_ATTACHMENT = createActionConst(TASK_SIMPLE_NAMESPACE, 'ADD_ATTACHMENT');

export const STORE_IS_FETCHED = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_IS_FETCHED');

export const STORE_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_TASK_SIMPLE');
export const CLEAR_TASK_SIMPLE = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_TASK_SIMPLE');

export const STORE_QI = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_QI');
export const CLEAR_QI = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_QI');

export const SAVE_TASK_ORDER = createActionConst(TASK_SIMPLE_NAMESPACE, 'SAVE_TASK_ORDER');
export const DND_TASK = createActionConst(TASK_SIMPLE_NAMESPACE, 'DND_TASK');

export const GET_SHARED_TASK = createActionConst(TASK_SIMPLE_NAMESPACE, 'GET_SHARED_TASK');

export const SAVE_TASK_SIMPLE_SOCKET = 'saveTask';
export const DELETE_TASK_SIMPLE_SOCKET = 'deleteTask';
export const SAVE_TASK_ORDER_SOCKET = 'saveTaskOrder';

export const INITIALIZE_TASK_PROPS = createActionConst(TASK_SIMPLE_NAMESPACE, 'INITIALIZE_TASK_PROPS');
export const CLEAR_TASK_PROPS = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_TASK_PROPS');

export const STORE_WATCHER = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_WATCHER');
export const CLEAR_WATCHER = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_WATCHER');

export const STORE_CREATED_TASK_ID = createActionConst(TASK_SIMPLE_NAMESPACE, 'STORE_CREATED_TASK_ID');
export const CLEAR_CREATED_TASK_ID = createActionConst(TASK_SIMPLE_NAMESPACE, 'CLEAR_CREATED_TASK_ID');
